import { createAction } from '@reduxjs/toolkit';

export interface IShowPayload {
  type?: string,
  payload: {
    delay: number,
  },
}

export const hide = createAction('HINT/HIDE');

export const show = createAction('HINT/SHOW', (delay = 0): IShowPayload => ({
  payload: {
    delay,
  },
}));

export const reshow = createAction('HINT/RESHOW', (delay = 0): IShowPayload => ({
  payload: {
    delay,
  },
}));

export const showApply = createAction('HINT/SHOW_APPLY');
